import { LandingFolderRestrictionApi } from './permission-api-client/api/landing-folder-restriction-api';
import { initializePermissionApi } from './utils';

// Dedicated API client for Landing Folder Restrictions (new Permission API)
export const landingFolderRestrictionApi = initializePermissionApi(LandingFolderRestrictionApi);
